import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, withViewTransitions } from '@angular/router';
import { KeycloakService } from '../../usermgmt/src/lib/services/keycloak.service';

import { EnvServiceProvider } from '../../usermgmt/src/public-api';
import { ApiResponseInterceptor, AuthInterceptorService, InitService } from 'usermgmt';
import { VlHttpService } from '../../usermgmt/src/lib/shared/vl-http/vl-http.service';
import { DatePipe } from '@angular/common';
import { routes } from './app/app.routes';
import { ErrorInterceptor } from './app/services/error.service';
import { provideZoneChangeDetection } from '@angular/core';
import { withPreloading } from '@angular/router';
import { StationChunkPreloadStrategy } from './app/station-chunk.preload.strategy';

const keycloakService = new KeycloakService();



keycloakService.init().then(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      ...(appConfig.providers || []),
      provideHttpClient(withInterceptorsFromDi()),
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(
        routes,
        withViewTransitions({ skipInitialTransition: true }),
        withPreloading(StationChunkPreloadStrategy)
      ),
      EnvServiceProvider,
      VlHttpService,
      InitService,
      DatePipe,
      { provide: KeycloakService, useValue: keycloakService },
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiResponseInterceptor,
        multi: true
      },
      {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
  ]
  }).catch(err => console.error(err));
});


window.addEventListener('error', (e) => {
  if (e.message?.includes('Failed to fetch dynamically imported module')) {
    window.location.reload();
  }
});